import { AxiosPromise } from 'axios';
import { Contact, CreateContactRequest } from '../../types/Contact';
import { libApiInstance } from '../axios';

export function requestContactById(contactId: number, signal?: AbortSignal): AxiosPromise<Contact> {
    //~ TIP: URL used matches contact fields endpoint but makes sense grouped with contact requests
    return libApiInstance.get(`/contacts/${contactId}/fields`, { signal });
}

export function requestCreateContact(
    data: CreateContactRequest,
    signal?: AbortSignal,
): AxiosPromise<Contact> {
    return libApiInstance.post('/contacts/create', data, { signal });
}

export function requestDeleteContact(
    contactId: number,
    signal?: AbortSignal,
): AxiosPromise<boolean> {
    return libApiInstance.delete(`/contacts/${contactId}`, { signal });
}
